import { render, staticRenderFns } from "./SuspectedPlayersBanAdd.vue?vue&type=template&id=4a488404&"
import script from "./SuspectedPlayersBanAdd.vue?vue&type=script&lang=js&"
export * from "./SuspectedPlayersBanAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports